import script from "./bigScreenAuthority.vue?vue&type=script&setup=true&lang=js"
export * from "./bigScreenAuthority.vue?vue&type=script&setup=true&lang=js"

import "./bigScreenAuthority.vue?vue&type=style&index=0&id=660578e8&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-660578e8"]])

export default __exports__